import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-snack-bar',
    standalone: true,
    imports: [
        MatButtonModule,
        MatSnackBarLabel,
        MatSnackBarActions,
        MatSnackBarAction
    ],
    templateUrl: 'snack-bar.component.html',
    styleUrl: 'snack-bar.component.css'
})
export class SnackBar {

    protected snackBarRef = inject(MatSnackBarRef);
    protected message: string = "";

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) {
        this.message = data;
    }
}